import React from "react";
import {
  Card,
  CardBody,
  Table,
} from "reactstrap";

/**
 * Returns a html component to display prediction summary
 * @param {Object} props 
 */
const PredictionSummary = (props) => {
  const predictionResult = props.predictionResult;
  const activeColor = props.activeColor !== null ? props.activeColor : "success";
  const textColor = "text-" + activeColor;
  const tableRows = [];
  for (const result of predictionResult) {
    const seqIdForDisplay = result.sequenceId.length > 40 ?
      result.sequenceId.substring(0, 40) + "..." :
      result.sequenceId;
    const tableRow = (<tr key={result.sequenceId}>
      <td><a href={`#${result.sequenceId}`}>{seqIdForDisplay}</a></td>
      <td>{result.contained_motifs.length === 0 ? "Does not contain any motif." : result.contained_motifs.join(", ")}</td>
    </tr>);
    tableRows.push(tableRow);
  }
  return (<div>
    <Card id="prediction_summary">
      <CardBody>
        <h3 className={textColor}><strong>Prediction Result Summary</strong></h3>
        <p>Prediction was performed in {predictionResult.length} sequence(s). </p>
        <Table className="table table-hover table-bordered w-100 text-wrap">
          <thead className="thead-light">
            <tr>
              <th scope="col" className="w-25">SequenceId</th>
              <th scope="col" className="w-75">Contained motif(s)</th>
            </tr>
          </thead>
          <tbody style={{fontFamily: "Monospace"}}>
            {tableRows}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  </div>);
}

export default PredictionSummary;